/**
 * نرمال‌سازی مشترک برای جستجوی فارسی/عربی (هدر، کتابخانه دوره‌ها، …)
 */

/** حذف تگٔ HTML؛ متن خام برای سرچ در توضیحات */
export function htmlToPlainSnippet(html: string | null | undefined, maxLen: number): string {
  if (!html) return '';
  const t = html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (t.length <= maxLen) return t;
  return `${t.slice(0, maxLen)}…`;
}

/**
 * نرمال‌سازی برای تطبیق جستجو بین فارسی/عربی:
 * نشانهٔ جهت، نیم‌فاصله/ZWSP/ZWJ، کشیدگی، اعراب، ی/ک عربی، انواع الف، ۀ/ة، لف لام‌الف، ارقام.
 */
export function normalizeFaSearch(s: string): string {
  if (!s) return '';
  let t = String(s)
    .replace(/[\u200E\u200F\u061C\u202A-\u202E\u2066-\u2069]/g, '')
    .replace(/[\u200B\u200C\u200D\uFEFF]/g, '')
    .replace(/\u0640/g, '')
    .replace(/[\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06ED]/g, '');

  t = t.replace(/\uFEFB/g, '\u0644\u0627').replace(/\uFEFC/g, '\u0644\u0627');
  t = t.replace(/\uFEF7/g, '\u0644\u0623').replace(/\uFEF8/g, '\u0644\u0623');
  t = t.replace(/\uFEF9/g, '\u0644\u0625').replace(/\uFEFA/g, '\u0644\u0625');

  t = t.replace(/[\u0622\u0623\u0625\u0671]/g, '\u0627');

  t = t.replace(/\u0629/g, '\u0647').replace(/\u06C0/g, '\u0647');

  t = t.replace(/[\u064A\u0649]/g, '\u06CC').replace(/\u0643/g, '\u06A9');

  t = t.replace(/[\u06F0-\u06F9]/g, (ch) => String(ch.charCodeAt(0) - 0x06f0));
  t = t.replace(/[\u0660-\u0669]/g, (ch) => String(ch.charCodeAt(0) - 0x0660));

  t = t
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
  return t;
}

/** آیا متن شامل عبارت جستجوست (بعد از نرمال‌سازی دو طرفه). عبارت خالی پس از نرمال‌سازی → false. */
export function haystackIncludesFa(haystack: string, needle: string): boolean {
  const n = normalizeFaSearch(needle);
  if (!n) return false;
  return normalizeFaSearch(haystack).includes(n);
}
